// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ":root{--light_text_color:#666}.sold-out-tag{color:#b12704;font-size:12px;font-weight:400;text-transform:uppercase;display:block}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
